import { useParams, useSearchParams } from "react-router-dom";
import MainLayout from "../common/components/MainLayout";
import useJuzgadoConfiguracionApi, { ConfiguracionJuzgado, ConfiguracionJuzgadoSave, ConfiguracionJuzgadoForm, ConfiguracionProduccionId } from "./useJuzgadoConfiguracionApi";
import DataSave from "../common/components/DataSave";
import { Checkbox, Form, Input, notification, Select } from "antd";
import { AxiosError } from "axios";

const JuzgadoConfiguracionSave = () => {
    const { id } = useParams();
    const api = useJuzgadoConfiguracionApi();
    const successRoute = "/juzgado/configuraciones";    
    const onAxiosError = (error: AxiosError) => {      
        if (error.response) {
          notification.error({
            placement: 'bottomRight',
            message: "Ha ocurrido un error en la devolución de la API"
          })
          return false;
        }
    };
    return (        
        <MainLayout title = "Guardar configuración de Juzgado">            
            <DataSave<ConfiguracionJuzgado, ConfiguracionJuzgadoSave, ConfiguracionJuzgadoForm>
                list={ (query) => api.list({ ...query, $expand: ["ConfiguracionesProduccion"] }) }
                save = { api.save }
                onAxiosError={ onAxiosError }
                transformOnLoad = { async (value) => ({ ...value, ConfiguracionesProduccion: value.ConfiguracionesProduccion.map((item: ConfiguracionProduccionId) => item.Id.toString()) })}
                transformOnSave = { async (value) => ({ ...value, ConfiguracionesProduccion: JSON.stringify(value.ConfiguracionesProduccion.map((item: string) => ({ id: Number(item) })))
                  //let newValue = { ...value}              
                  //ConfiguracionesProduccion: JSON.stringify(value.ConfiguracionesProduccion);
                  //console.log("Configuracion: ", newValue);
                  //return newValue;
                })}
                id = { id }
                successRoute = { successRoute }
                >

                <Form.Item
                rules = { [{ required: true, message: "Campo requerido" }] }
                required
                name = { "Nombre" }
                label = "Nombre"
                >                    
                  <Input />
                </Form.Item>

                <Form.Item
                rules = { [{ required: true, message: "Campo requerido" }] }
                required
                name = { "PeriodoCallCenter" }
                label = "Días de vencimiento"
                >                    
                  <Input />
                </Form.Item>

                <Form.Item
                required
                help = {"Ingrese los Ids de las Configuraciones de Produccion que quiere visualizar las infracciones en el módulo de Juzgado, Por ej: '1' "}
                name = {"ConfiguracionesProduccion"}
                label = "Identificadores configuraciones de produccion Juzgado"
                >
                  <Select
                  mode = "tags"
                  notFoundContent = "Ingrese uno o más Ids de configuraciones de producción"
                  allowClear
                  style = { { width: '250px' } }
                  placeholder = "Ingrese uno o más Ids de configuración de producción.."
                  options = { [] }
                  />
                </Form.Item>

                <Form.Item
                name="Deshabilitado"
                valuePropName="checked"
                tooltip="Puede habilitar/deshabilitar la funcionalidad de descargos"                  
                >
                  <Checkbox>Deshabilitar descargos</Checkbox>
                </Form.Item>
                
            </DataSave>
        </MainLayout>
    )
};

export default JuzgadoConfiguracionSave;